import * as React from "react";
import { IPublicationsReportPresenter } from "../../../presenter/report/PublicationsReportPresenter";
import PublicationsReportPreview from "../../components/report/publicationsReportComponents/PublicationsReportPreview";
import { Typography, Divider, Icon } from "antd";
import PublicationsReportPDFLink from "../../components/report/publicationsReportComponents/PublicationsReportPDFLink";

export interface Props {}

export interface State extends IPublicationsReportPresenter {}

export default class PublicationsReportPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const { translate, applicants } = this.state;

    const XLSX_PATH = "/api/reports/publications/xlsx";

    return (
      <div style={{ overflow: "hidden", width: "100%" }}>
        {applicants && (
          <div style={{ paddingLeft: 10 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <Typography.Title style={{ fontSize: 14 }}>
                {translate("reports.review_report")}
              </Typography.Title>
              <div>
                {!this.state.loaders.publicationsReportLoader &&
                  applicants.length > 0 && (
                    <PublicationsReportPDFLink
                      translate={translate}
                      applicants={applicants}
                      title={translate("publications_report.title")}
                      fileName={`${translate(
                        "publications_report.pdf_filename"
                      )}.pdf`}
                    />
                  )}
                <Divider
                  type={"vertical"}
                  style={{ fontSize: 10, height: "100%" }}
                />
                {applicants.length > 0 && (
                  <a
                    key="file-excel"
                    href={XLSX_PATH}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon
                      type="file-excel"
                      theme={"outlined"}
                      style={{ fontSize: 20, color: "#20744B" }}
                    />
                  </a>
                )}
              </div>
            </div>
            <Divider type={"horizontal"} />
            <PublicationsReportPreview
              translate={translate}
              applicants={applicants || []}
              title={translate("publications_report.title")}
            />
          </div>
        )}
      </div>
    );
  }
}
